import { styled } from '@linaria/react';
import { layout, primitives, semantic, size, space, textStyle } from '../../theme/tokens';

export const CarouselWrapper = styled.div`
  width: 100%;
`;

export const CarouselHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${space['space-1000']};
`;

export const CarouselTitle = styled.h2`
  font-family: ${textStyle.headline['size-lg'].fontFamily};
  font-size: ${textStyle.headline['size-lg'].fontSize};
  font-weight: ${textStyle.headline['size-lg'].fontWeight};
  line-height: ${textStyle.headline['size-lg'].lineHeight};
  letter-spacing: ${textStyle.headline['size-lg'].letterSpacing};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const ArrowGroup = styled.div`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: flex;
    align-items: center;
    padding: ${space['space-100']};
    border-radius: ${size.radius['radius-full']};
    background: ${semantic.bg.surfaceSubtle};
    backdrop-filter: blur(${size.blur['blur-lg']});
  }

  &[data-variant='blur'] {
    background: ${semantic.bg.overlayBlur};
    backdrop-filter: blur(${size.blur['blur-lg']});
  }
`;

export const CarouselTrack = styled.div`
  display: flex;
  gap: ${space['space-600']};
  margin-left: calc(-1 * var(--carousel-edge-inset, 0));
  padding-left: var(--carousel-edge-inset, 0);
  padding-right: var(--carousel-edge-inset, 0);
  scroll-padding-left: var(--carousel-edge-inset, 0);
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    scroll-snap-align: start;
    flex-shrink: 0;
    width: var(--carousel-child-width-mobile, var(--carousel-child-width));

    @media (min-width: ${layout.desktopBreakpoint}) {
      width: var(--carousel-child-width);
    }
  }
`;

export const ProgressTrack = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${space['space-1000']};
`;

export const ProgressBarOuter = styled.div`
  width: ${primitives.size['size-6000']};
  height: ${primitives.size['size-100']};
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${size.radius['radius-full']};
  overflow: hidden;
  position: relative;
`;

export const ProgressBarInner = styled.div`
  height: 100%;
  background: ${semantic.bg.primary};
  border-radius: ${size.radius['radius-full']};
  position: absolute;
  left: 0;
  transition: left 0.05s ease-out;
`;
